import styled from '@emotion/styled';

const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, #1a1a1a, #2a1a15);
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('/images/Heatwave_2.jpg') center/cover;
    opacity: 0.4;
    mix-blend-mode: soft-light;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at center, transparent 0%, rgba(0,0,0,0.7) 100%);
  }
`;

const SmokeBackground = () => {
  return <Background />;
};

export default SmokeBackground; 